import api from '../api'

const paymentService = {
    activateTrial: async (data) => {
        try {
            const response = await api.post('/activate-trial', data)
            return response.data
        } catch (error) {
            console.error('Error activating trial:', error)
            throw error
        }
    },
}

export default paymentService;